// Trip time vs real time, as AppClock / RealClock on the apps (IMPL-CONNECT A2). Real time is for
// stamps (ids, HLCs, updatedAt, deletedAt); trip time decides "today" and "now" on the trip, and
// the dev-only trip simulator can move it (`?now=2026-11-11T10:12:00+09:00&speed=60`).

export interface Simulation {
  /** Simulated ms at `anchor`. */
  at: number;
  /** Real ms when the simulation was (re)anchored. */
  anchor: number;
  speed: number;
  paused: boolean;
  /** The trip's zone, for the band. */
  tz?: string;
}

const KEY = 'pf.sim.clock';
let sim: Simulation | null = null;

export const realNow = (): number => Date.now();
/** An ISO stamp of real time, for synced fields. */
export const stampNow = (): string => new Date(realNow()).toISOString();

export function tripNow(): number {
  if (!sim) return realNow();
  return sim.paused ? sim.at : sim.at + (realNow() - sim.anchor) * sim.speed;
}

export const simulation = (): Simulation | null => sim;

export function simulate(next: Simulation | null): void {
  if (!import.meta.env.DEV) return;
  sim = next;
  try {
    if (next) sessionStorage.setItem(KEY, JSON.stringify(next));
    else sessionStorage.removeItem(KEY);
  } catch {}
  window.dispatchEvent(new Event('pf-clock'));
}

if (import.meta.env.DEV && typeof window !== 'undefined') {
  const params = new URLSearchParams(window.location.search);
  const at = params.get('now');
  if (at && !Number.isNaN(Date.parse(at))) {
    simulate({
      at: Date.parse(at),
      anchor: realNow(),
      speed: Number(params.get('speed') ?? 1) || 1,
      paused: params.has('paused'),
    });
  } else {
    try {
      const saved = sessionStorage.getItem(KEY);
      if (saved) sim = JSON.parse(saved) as Simulation;
    } catch {}
  }
}
